import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React, { useEffect, useState } from 'react';
import { Loading, useNotify } from 'react-admin';
import QRCode from "react-qr-code";
import { formatAdresse, formatDate, json } from '../references';

const useStyles = makeStyles({
    numFact:{padding:0,margin:0,color:'#28B463', fontWeight: 'bold'},
    dateFact:{marginLeft:302},
    padding:{padding:0,margin:0,fontSize:12},
    bold: { fontWeight: 'bold',fontSize:10,padding:0,margin:0 },
    seq: { textAlign: 'center',fontSize:40,padding:0,margin:0,fontWeight: 'bold' },
    code: { textAlign: 'center',fontSize:50,padding:0,margin:0,fontWeight: 'bold'},
    separateur : { borderWidth: 2,borderTopStyle:'dashed',borderBottomStyle: 'dashed',borderColor:'#D3D3D3'}, // or borderTop: '1px solid red'
    legend: { color: '#9E9BA1', marginTop: 10, fontSize: 10 },

});

const EtiqPlusieurs = ( props ) => {
    const classes = useStyles();
    const notify = useNotify();
    const { record,allCampEtiq } = props;
    const [listeEtique, setListeEtique] = useState();

    useEffect(() => {
        
        if(record && record.id){
            const URI=allCampEtiq ?'/etiq/getAllFactEtiquettes/'+record.id: '/etiq/getFactureEtiquettes/'+record.id;
            fetch(process.env.REACT_APP_URL+URI, { 
                method: 'GET',
                headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }).then(json)
            .then((data) => {
                setListeEtique(data.listeEtique);
            }).catch((e) => {
                notify("Erreur lors de l'affiage des étiuqettes.", 'warning')
            });
        }

    }, []);

    if(!listeEtique) return <Loading />

    return (
        <Paper className={classes.container} elevation={10}>
            <Table >
                <TableBody>
                    {listeEtique.map((item,index) =>
                        (<>                        
                        {index+1%4===0 ? <div key={"i"+item.etiq_id} className="page-break" />:null}
                        <TableRow key={"row"+item.etiq_id}>
                            <TableCell  className={classes.separateur}>
                                <p className={classes.seq}>{item.numEtique}</p>
                                <p className={classes.code}>{allCampEtiq? item.ord_code:record.order.code}</p>
                            </TableCell>
                            
                            <TableCell  className={classes.separateur} >
                                <QRCode size={160} level={"H"} value={'https://tldilogistique.com?q='+Buffer.from(item.id+'/'+item.etiq_id).toString('base64')}/>
                            </TableCell>                          
                            <TableCell  className={classes.separateur} >
                                <p className={classes.bold}>TLDI LOGISTIQUE SERVICES : {allCampEtiq?item.camp_code : record.order.campagne.code}</p>
                                <p className={classes.padding}>Tel : +33973648929 </p>
                                <p className={classes.padding}>Tel : +224660267474 </p>
                                <p className={classes.bold}>Destinataire</p>
                                <p className={classes.padding}>{allCampEtiq?item.dest_fullname :record.order.client_dest.fullname}</p>
                                <p className={classes.padding}>Tel : <a href={"tel:"+allCampEtiq?item.dest_tel:record.order.client_dest.telephone1}>{allCampEtiq?item.dest_tel:record.order.client_dest.telephone1}</a></p>
                                <p className={classes.padding}>{allCampEtiq?item.adresse:(record.order.client_dest.adresse ? "Adresse : "+formatAdresse(record.order.client_dest.adresse):"")}</p>
                                <p className={classes.padding}>{"Date : "+allCampEtiq?formatDate(item.createdDate):formatDate(item.createdDate)}</p>
                                <legend className={classes.legend}>
                                    <i>Flashez ce qrcode afin de découvrir tous nos services, ainsi que nos prochains départs, nous seront ravis de vous transporter vos prochains colis !!, Merci de votre confiance.</i> 
                                </legend>
                            </TableCell>
                        </TableRow>
                        </>
                        )
                    )}
                </TableBody>
            </Table>
        </Paper>
    );
};

export default EtiqPlusieurs;
